// frontend/src/hooks/useSocketInstance.js
import { useRef, useEffect } from 'react';
import { socket } from '../socket';

/**
 * Хук для управления единственным экземпляром socket
 * Предотвращает создание множественных подключений
 */
export const useSocketInstance = () => {
    const socketRef = useRef(socket);
    const isInitialized = useRef(false);

    useEffect(() => {
        if (!isInitialized.current) {
            console.log('🔌 [SOCKET-INSTANCE] Инициализация единственного экземпляра Socket.IO');
            
            // Подключаемся только если еще не подключены
            if (!socketRef.current.connected) {
                socketRef.current.connect();
            }
            
            isInitialized.current = true;
        }

        return () => {
            // НЕ отключаем socket при размонтировании хука - он может использоваться в других местах
            console.log('🔌 [SOCKET-INSTANCE] Hook размонтирован, но socket остается активным для переиспользования');
        };
    }, []);

    return socketRef.current;
};
